import styled from '@emotion/styled';
import { Button } from '@mui/material';

export const BusinessDropDownButton = styled(Button)({
  width: '340px',
  maxWidth: '540px',
  height: '40px',
  display: 'flex',
  justifyContent: 'space-between',
  border: '1px solid #E7E7E7',
  color: '#919191',
  textAlign: 'left',
});
